import React from 'react';
import Modal from 'react-bootstrap/Modal';

function ViewImageModal({ imageUrl, showModal, handleClose }) {
    return (
        <Modal show={showModal} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Image Preview</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {/* Only show the image */}
                <div style={{ textAlign: 'center' }}>
                    {imageUrl ? <img
                        src={imageUrl}
                        alt="Preview"
                        style={{ width: '100%', height: 'auto', maxWidth: '100%', maxHeight: '400px' }}
                    /> : <p>Please upload a banner</p>}

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="bttn-close" onClick={handleClose}>
                    Close
                </button>
            </Modal.Footer>
        </Modal>
    );
}

export default ViewImageModal;
